




















import Vue, { VueConstructor } from 'vue';
import { IPagination, IState } from '@/store/state';
import { setPage } from '@/store/actions';

interface ListPaginationComputed {
	text: string;
	pagination: IPagination;
	canNext: boolean;
	canPrev: boolean;
	nextText: string;
	previousText: string;
	buttons: any[];
}

interface ListPaginationMethods {
	prev(): void;
	next(): void;
	goTo(index: number): void;
}

export default Vue.extend<{}, ListPaginationMethods, ListPaginationComputed, {}>({
	computed: {
		pagination(){
			return (this.$store.state as IState).pagination;
		},
		text(){
			return `Sida ${this.pagination.current + 1} av ${this.pagination.max + 1}`;
		},
		canNext(){
			return this.pagination.current + 1 <= this.pagination.max;
		},
		canPrev(){
			return this.pagination.current - 1 >= 0;
		},
		nextText() {
			return 'Nästa';
		},
		previousText() {
			return 'Föregående';
		},
		buttons() {
			const makeButton = (index: number) => ({
				id: `pagianation-${index}`,
				index,
				label: index + 1,
				active: this.pagination.current === index,
				type: 'button'
			})
			const makeSpacer = (index: number) => ({
				id: `spacer-${index}`,
				type: 'spacer'
			})

			if(this.pagination.max <= 5) {
				return Array(this.pagination.max + 1).fill(0).map((_, index) => makeButton(index));
			}
			else if(0 <= this.pagination.current && this.pagination.current <= 2) {
				return [
					makeButton(0),
					makeButton(1),
					makeButton(2),
					makeButton(3),
					makeSpacer(4),
					makeButton(this.pagination.max)
				]
			}
			else if(3 <= this.pagination.current && this.pagination.current <= this.pagination.max - 3) {
				return [
					makeButton(0),
					makeButton(this.pagination.current - 1),
					makeButton(this.pagination.current),
					makeButton(this.pagination.current + 1),
					makeSpacer(5),
					makeButton(this.pagination.max)
				]
			} else {
				return [
					makeButton(0),
					makeSpacer(1),
					makeButton(this.pagination.max - 3),
					makeButton(this.pagination.max - 2),
					makeButton(this.pagination.max - 1),
					makeButton(this.pagination.max)
				]
			}
			return []
		}
	},
	methods: {
		prev() {
			if(this.canPrev) {
				this.$store.dispatch(setPage(this.pagination.current - 1));
			}
		},
		next() {
			if(this.canNext) {
				this.$store.dispatch(setPage(this.pagination.current + 1));
			}
		},
		goTo(index: number) {
			this.$store.dispatch(setPage(index));
		}
	}
})
